import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UsuarioService } from 'src/app/services/shared/usuario.service';
import { PersonasListadoComponent } from '../personas-listado/personas-listado.component';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

@Component({
    selector: 'app-modal-detalle',
    templateUrl: './modal-detalle.component.html',
    styleUrls: ['./modal-detalle.component.scss'],
})
export class ModalDetalleComponent implements OnInit, OnDestroy {
    sede: SignoSede = undefined;
    flag = false;
    sedes: SignoSede[];
    sedeAsignada: string = undefined;
    form: FormGroup;
    btnActualizar = false;
    guardandoSede = false;

    constructor(
        public dialogRef: MatDialogRef<PersonasListadoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private signoSedeService: SignoSedeService,
        private usuarioService: UsuarioService,
        private modalCustom: PopUpModalCustomService
    ) {}

    ngOnDestroy(): void {
        this.modalCustom.cerrar();
    }

    async ngOnInit(): Promise<void> {
        this.buildForm();
        await this.getSedes();
        await this.getUser(this.data.idUser);
    }

    // =====================================================
    // Datos
    // =====================================================

    buildForm(): void {
        this.form = new FormGroup({
            signoSedes: new FormControl('', Validators.required),
        });
    }

    async getSedes(): Promise<void> {
        this.sedes = await this.signoSedeService.getSedes();
    }

    async getUser(id: string): Promise<void> {
        const usuario = await this.usuarioService.getFindOne(id);
        const signoSede: any = usuario?.signoSedes?.[0];
        await this.getSedeById(signoSede);
    }

    async getSedeById(id: string): Promise<void> {
        if (id !== undefined && id !== null) {
            this.sede = await this.signoSedeService.getSedeById(id);
            this.sedeAsignada = this.sede ? this.sede._id : null;
            this.form.patchValue({ signoSedes: this.sedeAsignada });
        } else {
            this.flag = true;
        }
    }

    onSedeChange(event: Event): void {
        this.sedeAsignada = (event.target as HTMLSelectElement).value;
    }

    // =====================================================
    // Guardar
    // =====================================================

    async guardarSede(): Promise<void> {
        if (!this.form?.valid || this.btnActualizar) {
            return;
        }

        this.btnActualizar = true;
        this.guardandoSede = true;

        try {
            const sede = [this.form.value.signoSedes];
            await this.signoSedeService.updateSedeUser(this.data.idUser, sede);

            this.modalCustom.abrirPopup({
                tipo: 'success',
                titulo: 'Sede actualizada',
                mensaje: 'La sede del usuario se guardó correctamente.',
                textoBoton: 'Entendido',
                accionConfirmar: () => this.dialogRef.close(this.data),
            });
        } catch (error) {
            this.btnActualizar = false;
            this.modalCustom.abrirPopup({
                tipo: 'error',
                titulo: 'No se pudo guardar',
                mensaje: 'Ocurrió un error al actualizar la sede. Intentá nuevamente.',
                textoBoton: 'Entendido',
            });
        } finally {
            this.guardandoSede = false;
        }
    }
}
